import React from 'react'

import { Button, Text } from 'components/ds'

type Props = Omit<React.ComponentProps<typeof Button>, 'children'> & {
  count: number
}

// Shared with the measuring copy so "+N more" is always measured at its real width
const MoreBadgeButton = ({ count, ...buttonProps }: Props): React.ReactNode => (
  <Button size="2" variant="soft" color="gray" {...buttonProps}>
    <Text as="span" size={{ initial: '1', sm: '2' }}>
      +{count} more
    </Text>
  </Button>
)

export default MoreBadgeButton
